<template>
    <div class="edit_status_overlay" :style="styleString" v-show="isShow">
        <ReservationMenuItem
            v-for="(s, index) in statuses" :key="index"
            :status="s"
            @selectStatus="action_SelectStatus"
        />
        <hr>
        <button @click="action_ReservationCopy">
            <v-icon>mdi-content-copy</v-icon>
            <span class="txt">{{ $t('reservationwindow.reservationmonitor.label_reservation_copy') }}</span>
        </button>
        <button @click="action_ReservationCut">
            <v-icon>mdi-content-cut</v-icon>
            <span class="txt">{{ $t('reservationwindow.reservationmonitor.label_reservation_move') }}</span>
        </button>
        <button @click="action_ReservationRemove">
            <v-icon>mdi-trash-can-outline</v-icon>
            <span class="txt">{{ $t('reservationwindow.reservationmonitor.label_reservation_remove') }}</span>
        </button>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import ReservationMenuItem from './ReservationMenuItem.vue'

import { sheetState } from '../../../sheet-state'
import { closePopup, hideReservationMenu, sheetOverlays } from '../../../sheet-overlays'
import { TimeSelectModeType, reservationSelection, setSelectedReservation, setTimeSelectMode } from '../../../reservation-selection'
import { sheetFilters } from '../../../sheet-filters'
import { updateReservation, removeReservation } from '../../../reservation-actions'

export default {
    components: { ReservationMenuItem },
    data() {
        return {
            sheetState,
            sheetOverlays,
            reservationSelection,
            sheetFilters,
            position: { top: 0, left: 0 }
        }
    },
    watch: {
        mousePosition: {
            deep: true,
            handler: function (newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.updateFrame()
                    })
                }
            }
        },
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowReservationMenu
        },
        mousePosition: function () {
            return this.sheetOverlays.reservationMenuPosition ?? { x: 0, y: 0 }
        },
        styleString: function () {
            return 'top: ' + this.position.top + 'px;' + ' left: ' + this.position.left + 'px;'
        },
        statuses: function () {
            return this.sheetFilters.states
        },
        reservation: function () {
            return this.reservationSelection.selectedReservation
        },
        hservice: function() {
            return this.reservation?.hserviceID
        },
        isJoin: function() {
            return this.hservice?.lastLogin != undefined
        },
        isClosedService: function() {
            const closeReason = this.hservice.closeReason ?? []
            return closeReason.length > 0
        },
        isUsingKakaoAlrimTalk: function() {
            return this.servicesetting.setting.usingKakaoAlimAndFriendTalkLinkage
        },
        canSendMessage: function() {
            return (this.isClosedService == false) && (this.isUsingKakaoAlrimTalk == true || this.isJoin == true)
        }
    },
    mounted() {
        this.addEventListener()
    },
    beforeDestroy() {
        this.removeEventListener()
    },
    methods: {
        // MARK: - Private
        updateFrame() {
            let target = this.$el
            if (!target) {
                this.position = { top: this.mousePosition.y, left: this.mousePosition.x }
            } else {
                let { scrollWidth, scrollHeight } = this.sheetState.sheetScrollElement
                let top = (this.mousePosition.y + target.offsetHeight > scrollHeight) ?
                    (this.mousePosition.y - target.offsetHeight) :
                    this.mousePosition.y
                let left = (this.mousePosition.x + target.offsetWidth > scrollWidth) ?
                    (this.mousePosition.x - target.offsetWidth) :
                    this.mousePosition.x

                this.position = { top, left }
            }
        },
        // MARK: - Actions
        async action_SelectStatus(status) {
            hideReservationMenu()
            if (status._id == this.reservation.statusID._id) { return }

            let r = deepCopy(this.reservationSelection.selectedReservation)
            const fromAi = r.columnID.isAi && r.needConfirm
            const isCancel = status.isCancelStatus
            const aiMessageType = fromAi && isCancel ? 'cancel' : undefined
            r = {
                _id: r._id,
                hospitalID: r.hospitalID,
                userID: r.userID,
                hserviceID: r.hserviceID,
                groupID: r.groupID,
                columnID: r.columnID,
                statusID: status._id
            }
            this.sheetState.isSheetLoading = true
            try {
                await updateReservation(r, true, this.canSendMessage, aiMessageType)
            } finally {
                this.sheetState.isSheetLoading = false
            }
        },
        action_ReservationCopy() {
            let reservation = deepCopy(this.reservationSelection.selectedReservation)
            let hservice = deepCopy(reservation.hserviceID)
            setTimeSelectMode(hservice, reservation, TimeSelectModeType.copy)
            hideReservationMenu()
        },
        action_ReservationCut() {
            let reservation = deepCopy(this.reservationSelection.selectedReservation)
            let hservice = deepCopy(reservation.hserviceID)
            setTimeSelectMode(hservice, reservation, TimeSelectModeType.cut)
            hideReservationMenu()
        },
        async action_ReservationRemove() {
            const canSendMessage = this.canSendMessage
            hideReservationMenu()

            const needConfirm = this.reservation.needConfirm
            const fromAi = this.reservation.columnID.isAi && needConfirm
            const aiMessageType = fromAi ? 'cancel': undefined

            let result = await removeReservation(this.reservation, canSendMessage, aiMessageType)
            if (result?.data?.code != 0) {
                console.log(result)
                return
            }
            this.reservationSelection.selectedHService = undefined
            setSelectedReservation(undefined)
            if (canSendMessage == false) {
                closePopup()
            }
        },

        // MARK: - Event Listener
        addEventListener() {
            window.addEventListener('keyup', this.handleKeyUp)
        },
        removeEventListener() {
            window.removeEventListener('keyup', this.handleKeyUp)
        },
        handleKeyUp(e) {
            if (e.keyCode == 27) {
                if (this.sheetOverlays.isShowReservationMenu == false) {
                    hideReservationMenu()
                }
            }
        },
    }
}
</script>